<template>
    <div class="content-wrap">
        <div class="card-head">
            <div class="card-info flc">
                <div class="card-info-left">
                    <div class="card-info-left-top flc">
                        <div>{{ReportUserInfoData.uname}}</div>
                        <div>{{ReportUserInfoData.address}}</div>
                    </div>
                    <div class="card-info-left-bottom flc">
                        <div>电话：{{ReportUserInfoData.phone}}</div>
                        <div>签单手：{{ReportUserInfoData.sign_name}}</div>
                    </div>
                </div>
                <div class="card-info-right">意向</div>
            </div>
            <!-- <div class="record flc">
                <div class="record-text">跟进记录</div>
                <div class="record-line"></div>
                <div class="record-select flc" @click="choose">
                    <div>丢单</div>
                    <img src="@/assets/images/user/talk/triangle.png" alt="">
                    <div v-if="BchooseOrder" class="chooseOrder">
                        <p>抢单</p>
                        <p>丢单</p>
                        <p>抢单</p>
                        <p>抢单</p>
                    </div>
                </div>
            </div>
            <div class="progress flc">
                <img class="bg-line" src="@/assets/images/user/talk/background-line.png" alt="">
                <div class="progress-item" v-for="(item,index) in progress" :key="item.id">
                    <div class="progress-item-top">
                        <img class="isOK" v-if="index == 0" src="@/assets/images/user/talk/progress-end.png" alt="">
                        <img class="isOK" v-if="index == 1" src="@/assets/images/user/talk/ok.png" alt="">
                        <img class="isOK" v-if="index == 2||index == 3||index ==4" src="@/assets/images/user/talk/empty.png" alt=""> 
                        <div :class="item.status === 1 ? 'progress-item-name-end' : ( item.status === 2 ? 'progress-item-name-now' : 'progress-item-name-no')"><span>{{ item.name }}</span>
                            <img v-if="index==progress.length-1" src="@/assets/images/user/talk/triangle.png" alt="">
                        </div>
                    </div>
                    
                    <div :class="item.status === 1 ? 'progress-item-time-end' : 'progress-item-time-now'" v-if="item.status < 3">{{ item.time.substring(0, 10) }}<br>{{ item.time.substring(11, 16) }}</div>
                </div>
            </div>
            虚线分割线
            <img class="Dotted-line" src="@/assets/images/user/talk/border-bottom.png" alt="">
            <div class="tab-list flc">
                <div :class="['tab-item', index === curTab && 'tab-item-active']" v-for="(item, index) in tabList" :key="item.id" @click="changeTab(index)">
                    <img :src="index === curTab ? item.actSrc : item.src" alt="">
                    <div>{{ item.name }}</div>
                </div>
            </div> -->
        </div>
        <div class="content">
            <transition name="fade-transform" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>
    </div>
</template>

<script>
import { fetchVerifyAuthForB} from '@/libsV2/havc.js'

    export default {
        name: "customer", // 客户详情
        data() {
            return {
                BchooseOrder:false, //丢单选择
                accountId:'',
                progress: [
                    {
                        id: 1,
                        name: '创建',
                        time: '2021.10.24 20:14',
                        status: 1
                    },
                    {
                        id: 2,
                        name: '洽谈',
                        time: '2021.10.24 20:14',
                        status: 2
                    },
                    {
                        id: 3,
                        name: '勘测',
                        status: 3
                    },
                    {
                        id: 4,
                        name: '方案',
                        status: 3
                    },
                    {
                        id: 5,
                        name: '签约',
                        status: 3
                    },
                ],
                curTab: 3,
                tabList: [
                    {
                        id: 1,
                        name: '项目详情',
                        src: require('@/assets/images/user/talk/tab1.png'),
                        actSrc: require('@/assets/images/user/talk/tab1-act.png')
                    },
                    {
                        id: 2,
                        name: '勘察报告',
                        src: require('@/assets/images/user/talk/tab2.png'),
                        actSrc: require('@/assets/images/user/talk/tab2-act.png')
                    },
                    {
                        id: 3,
                        name: '定制方案',
                        src: require('@/assets/images/user/talk/tab3.png'),
                        actSrc: require('@/assets/images/user/talk/tab3-act.png')
                    },
                    {
                        id: 4,
                        name: '洽谈记录',
                        src: require('@/assets/images/user/talk/tab4.png'),
                        actSrc: require('@/assets/images/user/talk/tab4-act.png')
                    },
                    {
                        id: 5,
                        name: '施工进程',
                        src: require('@/assets/images/user/talk/tab5.png'),
                        actSrc: require('@/assets/images/user/talk/tab5-act.png')
                    },
                ]
            }
        },
        methods: {
            // 点击丢单触发得函数
            choose () {
                this.BchooseOrder = !this.BchooseOrder
            },
            /**
            * 切换tab
            */
            changeTab(index) {
                this.curTab = index
                switch (index) {
                    case 0:
                        this.skip('/hvac/talk/customer');
                        break;
                    case 3:
                        this.skip('/hvac/talk/record');
                        break;
                }
            },
            /**
            * 路由跳页
            */
            skip(path) {
                this.$router.replace({path})
            },
            // 获取潜客id
            getAccountId () {
                this.accountId = this.$route.query.accountid;
            }
        },
        created () {
            // $init(() => {
                fetchVerifyAuthForB (() => {
                    if (!this.$route.query.accountid) {
                        this.$toast({message: "参数缺失"})
                    } else {
                        this.getAccountId()
                        this.$store.dispatch({type: 'userTalkAppoint/getReportInfoData',accountid: this.accountId});
                    }
                })
            // })
        },
        computed:{
            //报告信息，用户信息
            ReportUserInfoData() {
                return this.$store.state.userTalkAppoint.ReportUserInfoData
            },
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrap {
        width: 100%;
        min-height: 100vh;
        background: #F0F4F1;

        .card-head {
            width: 93.6%;
            margin: 24px auto;
            border-radius: 12px;
            background: #fff;
            padding-bottom: 22px;

            /*信息*/
            .card-info {
                width: 100%;
                height: 166px;
                background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
                border-radius: 12px;
                padding: 24px 20px 20px 24px;
                justify-content: space-between;

                .card-info-right {
                    background: #FFFFFF;
                    border-radius: 22px;
                    border: 2px solid rgba(255, 255, 255, 0.3);
                    padding: 6px 34px 6px 32px;

                    font-size: 24px;
                    font-weight: 600;
                    color: #318544;
                    line-height: 34px;
                }

                .card-info-left {
                    width: 77.2%;
                    .card-info-left-top {
                        align-items: flex-start;
                        div:first-child {
                            white-space: nowrap;
                            font-size: 30px;
                            font-weight: 600;
                            color: #FFFFFF;
                            line-height: 44px;
                        }
                        div:last-child {
                            font-size: 24px;
                            font-weight: 400;
                            color: rgba(255, 255, 255, 0.87);
                            line-height: 32px;
                            margin-left: 15px;
                        }
                    }
                    .card-info-left-bottom {
                        margin-top: 16px;
                        display: flex;
                        justify-content: space-between;
                        div:first-child {
                            font-size: 28px;
                            font-weight: 400;
                            color: #FFFFFF;
                            line-height: 40px;
                        }
                        div:last-child {
                            font-size: 28px;
                            font-weight: 400;
                            color: #FFFFFF;
                            line-height: 40px;
                        }
                    }
                }
            }

            /*跟进记录*/
            .record {
                width: 100%;
                padding: 24px;
                justify-content: space-between;

                .record-text {
                    font-size: 28px;
                    font-weight: 400;
                    color: #444444;
                    line-height: 40px;
                }

                .record-line {
                    width: 406px;
                    border-top: 2px dashed #F1F1F1;
                }

                .record-select {
                    padding: 6px 6px 6px 12px;
                    border-radius: 4px;
                    border: 2px solid #A2A2A2;
                    justify-content: space-between;
                    align-items: flex-start;
                    position:relative;
                    font-size: 24px;
                    font-weight: 400;
                    color: #858585;
                    line-height: 32px;

                    img {
                        width: 24px;
                        height: 24px;
                    }
                    .chooseOrder {
                        z-index: 999;
                        position: absolute;
                        background-color: #ffffff;
                        left: 0;
                        top: 45px;
                        p{
                            border: solid grey 1px;
                            // display: inline-block;
                            padding: 8px 18px;
                        }
                    }
                }
            }

            /*进度*/
            .progress {
                align-items: flex-start;
                justify-content: space-between;
                margin:0 24px;
                position: relative;
                .bg-line {
                    width: 82.6%;
                    height: 4px;
                    position:absolute;
                    left: 50%;
                    transform: translate(-50%);
                    top: 9%;
                }
                .progress-item {
                    
                    position: relative;
                    margin-bottom: 98px;

                    .progress-item-top {
                        .isOK {
                            background-color: #FFFFFF;
                            width: 36px;
                            height: 36px;
                            position: relative;
                            left: 50%;
                            transform: translate(-50%);
                            margin-bottom: 20px;
                        }
                        .progress-item-name-end {
                            width: 72px;
                            height: 44px;
                            border-radius: 4px;
                            border: 2px solid #318544;
                            box-sizing: border-box;
                            font-size: 24px;
                            font-weight: 400;
                            color: #318544;
                            line-height: 44px;
                            text-align: center;
                        }
                        .progress-item-name-now {
                            width: 72px;
                            height: 44px;
                            background: #318544;
                            border-radius: 4px;
                            font-size: 24px;
                            font-weight: 400;
                            color: #FFFFFF;
                            line-height: 44px;
                            text-align: center;
                        }
                        .progress-item-name-no {
                            // width: 72px;
                            height: 44px;
                            padding: 0 10.5px;
                            border-radius: 4px;
                            border: 2px solid #A2A2A2;
                            box-sizing: border-box;
                            font-size: 24px;
                            font-weight: 400;
                            color: #858585;
                            line-height: 44px;
                            text-align: center;
                            img {
                                width: 24px;
                                height: 24px;
                                margin: 0;
                                margin-top:8px;
                            }
                        }
                    
                        div {
                            img {
                                display: inline;
                                width: 24px;
                                height: 24px;
                            }
                        }
                    }
                     .progress-item-time-end {
                        position: absolute;
                        left: 0;
                        bottom: -60px;
                        font-size: 20px !important;
                        font-weight: 400;
                        color: #A2A2A2;
                        line-height: 28px;
                    }
                    .progress-item-time-now {
                        position: absolute;
                        bottom: -60px;
                        left: 0;
                        font-size: 20px!important;
                        font-weight: 400;
                        color: #318544;
                        line-height: 28px;
                    }
                    
                }
            }

            // 分割线
            .Dotted-line {
                display:block;
                margin-left: 24px;
                margin-bottom: 26px;
                width: 654px;
                height: 2px;
            }

            /*tab切换*/
            .tab-list {
                padding: 0 8px;
                justify-content: space-between;

                .tab-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 12px 16px 6px;

                    img {
                        width: 80px;
                        height: 80px;
                    }
                    div {
                        font-size: 24px;
                        font-weight: 600;
                        color: #A2A2A2;
                        line-height: 34px;
                        margin-top: 12px;
                    }
                }
                .tab-item-active {
                    background: rgba(49, 133, 68, 0.1);
                    border-radius: 6px;

                    div {
                        color: #318544;
                    }
                }
            }
        }
    }

    /*通用样式*/
    .flc {
        display: flex;
        align-items: center;
    }
    /*动画*/
    .fade-transform-leave-active,
    .fade-transform-enter-active {
        transition: all 0.4s;
    }
    .fade-transform-enter {
        opacity: 0;
        transform: translateX(-30px);
    }
    .fade-transform-leave-to {
        opacity: 0;
        transform: translateX(30px);
    }
</style>